/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from "react";
import { notification } from "antd";
import axios from "axios";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import {CONTACT_CREATOR_MODAL_ON_SUCCESS} from "../../index";

const useForm = (validate, url, subject, appId, action, creatorEmail,onClick ) => {
    const [values, setValues] = useState({});
    const [errors, setErrors] = useState({});
    const [spinner, setspinner] = useState(false);
    const [shouldSubmit, setShouldSubmit] = useState(false);
    const eb = EventBusModule.getInstance().getEventBus();
    const openNotificationWithIcon = type => {
        notification[type]({
            message: "Success",
            description: "Your message has been sent!",
            placement: "bottomRight"
        });
        
        setValues({});
    };


    
    const openNotificationWithIconError = type => {
        notification[type]({
            message: "Oops!",
            description: "Something went wrong, Please try again!",
            placement: "bottomRight"
        });
        
        // setValues({});
    };

   

    const handleSubmit = event => {
        console.log(`inside handle submit`, action, url, subject, creatorEmail,appId, values);
        event.preventDefault();
        setErrors(validate(values));
        if (onClick) {
            onClick("contact", subject);
        }
        // Your url for API
        //  const url = "";
        if (Object.keys(values).length === 3) {
           setspinner(true) 
            axios
                .post(url, {
                    // ...values,
                    email: values?.email,
                    name: values?.name,
                    message: values?.message,
                    subject: subject,
                    toEmail:creatorEmail,
                    appId:appId,
                    action:action,
                    fromUrl: window.location.origin,
                })
                .then(() => {
                    //   setTimeout(function () {
                        setspinner(false);
            //    }, 3000);
                   
                    setValues({});
                    setShouldSubmit(true);
                })
                .catch(err => {
                    setspinner(false);
                    openNotificationWithIconError("error");
                    setShouldSubmit(false);
                    
                    console.log("error in posting ", url, err);
                });
        }
    };

    useEffect(() => {
        if (Object.keys(errors).length === 0 && shouldSubmit) {
            setValues("");
            openNotificationWithIcon("success");
            eb.emit(CONTACT_CREATOR_MODAL_ON_SUCCESS, null, {});
        }
    }, [errors, shouldSubmit]);

    const handleChange = event => {
        event.persist();
        setValues(values => ({
            ...values,
            [event.target.name]: event.target.value
        }));
        setErrors(errors => ({ ...errors, [event.target.name]: "" }));
    };

    return {
        handleChange,
        handleSubmit,
        values,
        errors,
        shouldSubmit,
        spinner
    };
};

export default useForm;
